import React from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/lib/connect/connect';
import bindActionCreators from 'redux/lib/bindActionCreators';
import moment from 'moment';
import { toast } from 'react-toastify';
import queryString from 'query-string';

import * as PayrollSettingDucks from 'ducks/payrolls/setting';
import * as UserDucks from 'ducks/accounts/user';
import * as BasicSettingDucks from 'ducks/vendors/basicSetting';
import * as RouteDucks from 'ducks/routes';
import * as NotificationSettingDucks from 'ducks/vendors/notificationSetting';

import { MSGS } from 'constants/payrolls';

import SectionLoaderAtom from 'atoms/SectionLoader';
import PayrollSettingFormComponent from 'components/payrolls/setting/advancedPayrollForm';
import CaliforniaRuleModal from 'components/payrolls/setting/CaliforniaRuleModal';
import AddMealRuleModal from 'components/payrolls/setting/AddMealRuleModal';
import DeleteMealModalComponent from 'components/payrolls/setting/DeleteMealModal';
/**
 * PayrollSettingFormPage -> PayrollSettingFormSection
 *
 * Components:
 *    - {@link PayrollSettingFormComponent}
 *
 * State:
 *    - payroll detail
 *
 * Actions:
 *    - Form:
 *        - Update payroll detail
 */
class PayrollSettingAdvanceFormSection extends React.Component {
  constructor(props) {
    super(props);
    this.createOrUpdate = this.createOrUpdate.bind(this);
    this.state = {deletingMeal: false,isOpen: false,  californiaRuleMessage: null , OvertimeInfo: false, mealBreakInfo: false,
      openAddRuleModal: false, openDeleteRuleModal: false, editMealDetail:null, addMealLoader:false, deleteMealId: null, deleteMealLoader: false, payroll_id : null, mealRuleList: null,isActivePayroll:true}
    this.toggleModal = this.toggleModal.bind(this);
    this.updateCaliforniaRuleMessage = this.updateCaliforniaRuleMessage.bind(this);
    this.toggleOvertimeAccordian = this.toggleOvertimeAccordian.bind(this);
    this.toggleMealBreakAccordian = this.toggleMealBreakAccordian.bind(this);
    this.toggleAddRuleModal = this.toggleAddRuleModal.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.saveData = this.saveData.bind(this);
    this.openEditForm= this.openEditForm.bind(this);
    this.openDeleteFormModal = this.openDeleteFormModal.bind(this);
    this.openDeleteForm = this.openDeleteForm.bind(this);
    this.updateMeal = this.updateMeal.bind(this);
    this.getMealRulesList = this.getMealRulesList.bind(this);
    this.isPayrollActive=this.isPayrollActive.bind(this);
  };

  componentWillMount(){
    const { advancedPayrollModalType } = this.props;
    this.setState({payroll_id : this.props.detail && this.props.detail.id, isActivePayroll : this.props.detail && this.props.detail.id  ? this.props.detail.is_active : true })
    this.setState({ californiaRuleMessage :  this.props.detail && this.props.detail.id  ? this.props.detail.cal_7_day_rule_message :  MSGS.CALIFORNIA_DEFAULT_MESSAGE });
  }

  getMealRulesList(){
     const { router: { route: { match: { params } } } } = this.context;
     const { advancedPayrollModalType } = this.props;
     this.props.PayrollSettingDucks.getAdvancedPayrollMealList(this.state.payroll_id)
     .then((res) => {
        this.setState({mealRuleList : res.value})
    })
  }

  componentWillReceiveProps(nextProps){
    const { advancedPayrollModalType } = this.props;
    const { router: { route: { match: { params } } } } = this.context;
    this.setState({ californiaRuleMessage: MSGS.CALIFORNIA_DEFAULT_MESSAGE });
    if(this.props.detail !== nextProps.detail && nextProps.detail){
      this.setState({payroll_id : nextProps.detail.id, isActivePayroll : nextProps.detail.is_active})
    }
    if(this.state.payroll_id){
      this.setState({ californiaRuleMessage : nextProps.detail.cal_7_day_rule_message });
    }else{
      this.setState({ californiaRuleMessage: MSGS.CALIFORNIA_DEFAULT_MESSAGE });
    }
  }

  updateMeal(notification, extraData, data, id){
    const { advancedPayrollMealsList, advancedPayrollModalType } = this.props;
    const { router: { route: { match: { params } } } } = this.context;
    this.setState({addMealLoader : true});
    const detail ={
     payroll_setting: this.state.payroll_id,
     config: 'Meal',
     sequence_of_configurations: (+advancedPayrollMealsList.length) + 1,
     include_rt_ot_dot: data.override_meal_payment === true ?  data.include_rt_ot_dot : false,
     is_default: data.is_default,
     extra_data: extraData,
     notifications: notification,
     is_meal_start_notification: data.is_meal_start_notification,
     is_meal_end_notification: data.is_meal_end_notification

  }
    return this.props.PayrollSettingDucks.updateAdvancedPayrollMeal(detail, id)
    .then(() => {
      this.getMealRulesList();
      toast.success('Meal Updated Successfully');
      this.setState({addMealLoader : false, openAddRuleModal : false})})
    .catch((err) => 
    {
      toast.error(err.non_field_errors[0]);
      this.setState({ openAddRuleModal: false, addMealLoader: false })});
  }

  openEditForm(params){
    const { advancedPayrollModalType } = this.props;
    this.props.PayrollSettingDucks.getAdvancedPayrollMealDetails(params)
      .then((response) => {
        const {openAddRuleModal} = this.state;
        this.setState({editMealDetail: response.value});
        this.setState({openAddRuleModal: !openAddRuleModal});})
  }

  openDeleteFormModal(params) {
    const { openDeleteRuleModal } = this.state;
    this.setState({ deleteMealId: params})
    this.setState({ openDeleteRuleModal: !openDeleteRuleModal })
  }

  openDeleteForm() {
    const { deleteMealId } = this.state;
    const { advancedPayrollModalType } = this.props;
    this.setState({deleteMealLoader : true , deletingMeal: true});
      this.props.PayrollSettingDucks.deleteAdvancedPayrollMeal(deleteMealId)
      .then(() => {
      this.setState({deleteMealLoader : false, deletingMeal:false});
      this.getMealRulesList();
      this.setState({openDeleteRuleModal: false});
      return toast.success('Meal deleted successfully');
      })
      .catch((err) => {
        this.setState({deleteMealLoader : false, deletingMeal:false});
        this.setState({openDeleteRuleModal: false});
        return toast.error(err.non_field_errors[0]);
      })
  }

  toggleMealBreakAccordian(){
    const { router: { route: { match: { params } } } } = this.context;
    const {mealBreakInfo, payroll_id} = this.state;
    this.setState({mealBreakInfo: !mealBreakInfo});
    if(payroll_id !== null){
    this.getMealRulesList();
    }
  }

  toggleAddRuleModal(){
    const {openAddRuleModal} = this.state;
    this.setState({editMealDetail : null});
    this.setState({openAddRuleModal: !openAddRuleModal});
  }

  toggleDeleteModal() {
    const { openDeleteRuleModal } = this.state;
    this.setState({
      openDeleteRuleModal: !openDeleteRuleModal
    })
  }

  saveData(notifications, extraData, data){
    const { advancedPayrollMealsList , advancedPayrollModalType } = this.props;
    const { router: { route: { match: { params } } } } = this.context;
    this.setState({addMealLoader : true});
    const detail ={
     payroll_setting: this.state.payroll_id,
     config: 'Meal',
     sequence_of_configurations: (+advancedPayrollMealsList.length) + 1,
     include_rt_ot_dot: data.override_meal_payment === true ?  data.include_rt_ot_dot : false,
     is_default: data.is_default,
     extra_data: extraData,
     notifications: notifications,
     is_meal_start_notification: data.is_meal_start_notification,
     is_meal_end_notification: data.is_meal_end_notification
  }
    this.props.PayrollSettingDucks.createAdvancedPayrollMeal(detail, params)
    .then(() => {
      toast.success('Meal Added Successfully');
      this.getMealRulesList();
      this.setState({openAddRuleModal: false, addMealLoader:false});
      })
    .catch(() => this.setState({ openAddRuleModal: false, addMealLoader: false }));
  }


  toggleOvertimeAccordian(){
    const {OvertimeInfo} = this.state;
    this.setState({OvertimeInfo: !OvertimeInfo});
  }

  toggleModal(){
    const { isOpen } = this.state;
    return this.setState({ isOpen: !isOpen });
  }

  updateCaliforniaRuleMessage(data) {
    this.setState({ californiaRuleMessage: data.cal_7_day_rule_message, isOpen: false });
  }

  createOrUpdate(data) {
    const { payroll_id } = this.state;
    const { userCompany, advancedPayrollModalType } = this.props;
    const { router: { history, route: { match: { params } } } } = this.context;
    const { location: { pathname, search } } = this.props;
    const query = queryString.parse(search);
    if(payroll_id){
      return this.props.PayrollSettingDucks.putAdvancedPayrollSetting(params.id, data, payroll_id)
      .then((response) => {
        this.props.fetchData(query)
        toast.success("Saved Successfully");
        this.setState({payroll_id : response.value.id})
      })
      .catch((err) => {
        if(err.non_field_errors.length){
          toast.error(err.non_field_errors[0]);
        }
      });
    }
     return this.props.PayrollSettingDucks.postAdvancedPayrollSetting(data, params)
      .then((response) => {
        this.props.fetchData(query)
        toast.success("Saved Successfully");
        this.setState({payroll_id : response.value.id})
      })
      .catch((err) => {
        if(err.non_field_errors.length){
          toast.error(err.non_field_errors[0]);
        }
      });
  }

  isPayrollActive(){
    const {isActivePayroll}= this.state;
    this.setState({isActivePayroll:!isActivePayroll})
  }

  render() {
    const { location: { pathname, query }, userExtraData , advancedPayrollModalType , dateFormat , parentPayrollDetail} = this.props;
    const isAdvancedSettingsVisible = query.isAdvancedSettingsVisible == 'true' ? true : false;
    const {editMealDetail } = this.state;
    const notifications = editMealDetail ? editMealDetail.notifications : null;
    const mealStartNotification = notifications ? notifications.find((i) =>
      i.notification_type === 'MEAL_START'):null;
    const mealEndNotification = notifications ? notifications.find((i) =>
      i.notification_type === 'MEAL_END'):null;
    const forceMealEndNotification = notifications ? notifications.find((i) =>
      i.notification_type === 'MEAL_FORCE_END'):null;
    const { isLoading, detail, timeFormat, userCompany, timeFormat24Hrs, showPayrollDetails, isEditPayroll} = this.props;
    const { router: { route: { match: { params } } } } = this.context;
    const { isOpen, californiaRuleMessage , openAddRuleModal, openDeleteRuleModal} = this.state;
    let mealBreakDuration = editMealDetail && editMealDetail.extra_data.duration ? editMealDetail.extra_data.duration : null;
    mealBreakDuration = mealBreakDuration ? mealBreakDuration.split(':') :null;
    let MealBreakHour = mealBreakDuration && mealBreakDuration[0] ? mealBreakDuration[0] : null;
    let MealBreakMinute = mealBreakDuration && mealBreakDuration[1] ? mealBreakDuration[1] : null;
    let initialValues = {};

    if (params.id && detail.id) {
      initialValues = { ...detail,
        hour: Math.floor(detail.first_meal_threshold / 3600),
        minute: Math.floor((detail.first_meal_threshold % 3600) / 60),
        wavier_hour: Math.floor(detail.meal_waiver_value / 3600),
        wavier_minute: Math.floor((detail.meal_waiver_value % 3600) / 60),
        daily_split: detail.daily_split,
        week_overtime_hours: detail.week_overtime_threshold && detail.week_overtime_threshold.hours,
        week_overtime_minutes: detail.week_overtime_threshold && detail.week_overtime_threshold.minutes,
        daily_overtime_hours: detail.daily_overtime_threshold && detail.daily_overtime_threshold.hours,
        daily_overtime_minutes: detail.daily_overtime_threshold && detail.daily_overtime_threshold.minutes,
        daily_double_overtime_hours: detail.daily_double_overtime_threshold && detail.daily_double_overtime_threshold.hours,
        daily_double_overtime_minutes: detail.daily_double_overtime_threshold && detail.daily_double_overtime_threshold.minutes,
        work_day_start_time: detail && detail.work_day_start_time ? detail.work_day_start_time : moment().set({ hour: 0, minute: 0 }).toISOString(),
      };
    }
    else {
      initialValues = {
        is_meal_paid : false,
        is_overtime_applicable: parentPayrollDetail && parentPayrollDetail.is_overtime_applicable ? parentPayrollDetail.is_overtime_applicable : false,
        is_additional_overtime_applicable: false,
        is_cal_7_day_rule: false,
        week_overtime_threshold: 40,
        daily_overtime_threshold: 8,
        daily_double_overtime_threshold:12,
        daily_split: false,
        work_day_start_time : '00:00',
        week_day: parentPayrollDetail && parentPayrollDetail.week_day ? parentPayrollDetail.week_day : 0
      }
    }

    return (
      <div>
        <PayrollSettingFormComponent
          initialValues={initialValues}
          isAdvancedSettingsVisible={isAdvancedSettingsVisible}
          toggle={this.toggleModal}
          toggleModal={this.toggleModal}
          createOrUpdate={this.createOrUpdate}
          californiaRuleMessage={californiaRuleMessage}
          timeFormat={timeFormat}
          timeFormat24Hrs={timeFormat24Hrs}
          userCompany={userCompany}
          OvertimeInfo={this.state.OvertimeInfo}
          toggleOvertimeAccordian={this.toggleOvertimeAccordian}
          toggleMealBreakAccordian={this.toggleMealBreakAccordian}
          mealBreakInfo={this.state.mealBreakInfo}
          toggleAddRuleModal={this.toggleAddRuleModal}
          openAddRuleModal={openAddRuleModal}
          mealsList={this.props.advancedPayrollMealsList}
          mealRuleList={this.state.mealRuleList}
          openEditForm={this.openEditForm}
          openDeleteFormModal={this.openDeleteFormModal}
          params={params}
          payroll_id={this.state.payroll_id}
          showAdvancedSettings={this.props.showAdvancedSettings}
          showPayrollDetails={showPayrollDetails}
          isEditPayroll={isEditPayroll}
          userExtraData={userExtraData}
          newLayout={this.props.newLayout}
          dateFormat={this.props.dateFormat}
          isPayrollActive={this.isPayrollActive}
          isActivePayroll={this.state.isActivePayroll}
          form="form2"
          advancedPayrollModalType={advancedPayrollModalType}
        />
        {isOpen &&
          <CaliforniaRuleModal
            initialValues={{ ...initialValues, cal_7_day_rule_message: californiaRuleMessage }}
            isOpen={isOpen}
            toggle={this.toggleModal}
            updateCaliforniaRuleMessage={this.updateCaliforniaRuleMessage}
          />
        }
        {openDeleteRuleModal &&
          <DeleteMealModalComponent
            isOpen={openDeleteRuleModal}
            toggle={this.openDeleteFormModal}
            openDeleteForm={this.openDeleteForm}
            deleteMealId={this.state.deleteMealId}
            deleteMealLoader ={this.state.deleteMealLoader}
            isSubmitting={this.state.deletingMeal}
          />
        }
        {openAddRuleModal &&
          <AddMealRuleModal
            isOpen={openAddRuleModal}
            payroll_id ={this.state.payroll_id}
            toggle={this.toggleAddRuleModal}
            saveData={this.saveData}
            company_id={userCompany.id}
            params={params}
            updateMeal={this.updateMeal}
            addMealLoader={this.state.addMealLoader}
            mealDetails={this.props.advancedPayrollMealDetails}
            initialValues={{ ...editMealDetail, override_meal_payment: editMealDetail ? editMealDetail.extra_data.override_meal_payment : null,
              MealStarthour: editMealDetail ? editMealDetail.extra_data.start_time.hours : null, MealStartminute: editMealDetail ? editMealDetail.extra_data.start_time.mins : null
              ,wavier_hour: editMealDetail ? editMealDetail.extra_data.waiver.hours : null, wavier_minute: editMealDetail ? editMealDetail.extra_data.waiver.mins : null,
              notification: (editMealDetail && editMealDetail.notifications.length)>0 ? true : false,
              mealStartNotificationTime: mealStartNotification && mealStartNotification.notification_after, mealStartNotification : mealStartNotification && mealStartNotification.notification_message,
              mealEndNotificationTime:mealEndNotification && mealEndNotification.notification_after, mealEndNotification: mealEndNotification && mealEndNotification.notification_message,
              AutomaticMealEndNotificationTime: forceMealEndNotification && forceMealEndNotification.notification_after, automaticMealEndNotification: forceMealEndNotification && forceMealEndNotification.notification_message,
              automatic_meal_end: editMealDetail && editMealDetail.extra_data.automatic_meal_end, MealBreakHour: MealBreakHour ? MealBreakHour : null, MealBreakMinute : MealBreakMinute ? MealBreakMinute : null
            }}
          />
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  detail: PayrollSettingDucks.advancedPayrollSettingDetail(state),
  parentPayrollDetail: PayrollSettingDucks.payrollSettingDetail(state),
  userCompany: UserDucks.userCompany(state),
  timeFormat: BasicSettingDucks.timeFormat(state),
  timeFormat24Hrs: BasicSettingDucks.timeFormat24Hrs(state),
  advancedPayrollMealsList: PayrollSettingDucks.advancedPayrollMealsList(state),
  advancedPayrollMealDetails:PayrollSettingDucks.advancedPayrollMealDetails(state),
  location: RouteDucks.location(state),
  userExtraData: UserDucks.userExtraData(state),
  dateFormat: BasicSettingDucks.dateFormat(state),
  payrollSettingDetail : PayrollSettingDucks.payrollSettingDetail(state)
});

const mapActionToProps = dispatch => ({
  PayrollSettingDucks: bindActionCreators(PayrollSettingDucks, dispatch),
  NotificationSettingDucks: bindActionCreators(NotificationSettingDucks, dispatch),
});

PayrollSettingAdvanceFormSection.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  detail: PropTypes.object.isRequired,
  PayrollSettingDucks: PropTypes.object.isRequired,
};

PayrollSettingAdvanceFormSection.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapActionToProps,
)(PayrollSettingAdvanceFormSection);
